export default __webpack_public_path__ + "static/media/PrivacyPolicy-NL.a95693bb.pdf";